import { isAction, Middleware, UnknownAction } from '@reduxjs/toolkit'
import { RootState } from '@/redux/store.ts'
import { authSlice, logout } from '@/features/auth/auth.slice.ts'
import { setLocalStorageItem } from '@/utils/local-storage.ts'

export const authPersistenceMiddleware: Middleware<UnknownAction, RootState> = ({
  getState,
}) => {
  return (next) => (action: unknown) => {
    const result = next(action)
    const state = getState()
    if (isAction(action) && action.type.startsWith(authSlice.name) && state.auth) {
      setLocalStorageItem(authSlice.name, state.auth)
    }

    if (isAction(action) && action.type === logout.type) {
      localStorage.removeItem(authSlice.name)
    }

    return result
  }
}
